<div class="bp-modal mod-md">
  <div class="bp-modal-body">
    <img
      class="best_popup__header"
      [src]="'/assets/images/best_two_popup.png'"
      [alt]="'best_two_popup_image_alt' | translate" />
    <div class="bp-modal-body-section">
      <div class="font-bold pb-20 font-size-24">{{ "best_two_popup_header" | translate }}</div>
      <div class="font-size-15 mod-suppress-hyphen">
        {{ "best_two_popup_subheader" | translate }}
        <ul class="best_popup__list-container">
          @for (item of [1, 2, 3, 4]; track item) {
            <li>{{ "best_two_list_item_" + item | translate }}</li>
          }
        </ul>
      </div>
      <div class="font-size-11 mod-suppress-hyphen best_popup__legal-text">
        {{ "best_two_legal_text_part_1" | translate }}
        <a [href]="getTermsLink()" target="_blank">{{ "best_two_legal_text_part_2" | translate }}</a>
        {{ "best_two_legal_text_part_3" | translate }}
      </div>
      <div class="best_popup__footer-container">
        <a class="best_popup__button-cancel font-medium" [tabIndex]="0" (click)="onLater()">{{
          "best_two_later_button" | translate
        }}</a>
        <button class="btn btn-primary font-medium best_popup__button-accept" (click)="onAccept()">{{
          "best_two_accept_button" | translate
        }}</button>
      </div>
    </div>
  </div>
</div>
